<ng-container *transloco="let t">
  <div class="flex flex-col gap-6">
    @if (!!accountMarketplace()?.dspAdvertiserId) {
      <app-compact-filter [filters]="filters()" (filterChange)="applyAdTypeFilter($event)" />
    }

    <app-metric-selector
      [data]="globalData()"
      [previousPeriodData]="previousPeriodGlobalData()"
      (selectedMetricsChange)="selectMetrics($event)"
      [availableMetrics]="CHART_METRICS"
      [localStorageKey]="localStorageKey"
      [dataLoading]="loading()"
    />

    @if (chartDisplayed) {
      @let isLineChart = chartDisplayMode === "lineChart";
      <app-chart-layout
        closable
        [withDateAggregation]="(dateAggregation$ | async) && isLineChart"
        [withEventAnnotation]="isLineChart"
        [displayEventAnnotation]="(displayEventAnnotation$ | async) ?? false"
        [disableEventAnnotation]="disableEventAnnotation()"
        [allEventAnnotationTypes]="allEventAnnotationTypes"
        [allStrategies]="(allStrategies$ | async) ?? []"
        [chartDisplayModes]="chartDisplayModeOptions"
        [selectedChartDisplayMode]="chartDisplayMode"
        [dataLoading]="loading()"
        (aggregationChange)="selectAggregation($event)"
        (closeClicked)="toggleChartDisplay(false)"
        (displayModeChange)="toggleChartDisplayMode($event)"
        (displayEventAnnotationChange)="toggleEventAnnotation($event)"
      >
        @if (chartDisplayMode === "donuts") {
          <div class="flex flex-1 flex-col items-center justify-center">
            <span class="text-xl font-medium">{{ t("overview.by_campaign_types", [mainMetric() | metricTitle]) }}</span>
            <IChart [config]="campaignTypeDonutChartConfig()" [data]="dailyCampaignStats()" />
          </div>
          <div class="flex flex-1 flex-col items-center justify-center">
            <span class="text-xl font-medium">{{ t("overview.by_strategy", [mainMetric() | metricTitle]) }}</span>
            <IChart [config]="strategyDonutChartConfig()" [data]="sortedStrategyStats() ?? []" />
          </div>
        } @else if (chartDisplayMode === "lineChart") {
          <div class="flex w-full items-center justify-center">
            <IChart [config]="chartConfig()" [data]="dailyCampaignStats()" />
          </div>
        }
      </app-chart-layout>
    } @else {
      <div class="flex justify-end">
        <button iButton variant="secondary" [iTooltip]="t('common.show_charts')" (click)="toggleChartDisplay(true)">
          <IIcon name="chartLine" />
          {{ t("common.show_charts") }}
        </button>
      </div>
    }
    <app-advertising-stats-grid
      [gridKey]="STRATEGY_GRID_KEY"
      class="mt-2 w-full"
      (export)="exportGridCsv()"
      [dataFilter]="campaignTypeStatsFilter()"
    />
  </div>
</ng-container>
